module.exports = __webpack_public_path__ + "img/2024big15.0a6a77d9.png";